import React from "react";
import Alert from "react-bootstrap/Alert";

export type AlertVariantType = "success" | "danger";

export type DismissableAlertProps = {
  variant: AlertVariantType;
  show: boolean;
  onClose: () => void;
  text: string;
};

export default function DismissableAlert(
  props: DismissableAlertProps
): JSX.Element {
  return (
    <Alert
      dismissible
      variant={props.variant}
      show={props.show}
      onClose={props.onClose}
    >
      {props.text}
    </Alert>
  );
}
